export const DOCUMENT_SHOW_CREATE_MODAL = 'DOCUMENT_SHOW_CREATE_MODAL';
export const DOCUMENT_SHOW_EDIT_MODAL = 'DOCUMENT_SHOW_EDIT_MODAL';
export const DOCUMENT_HIDE_CREATE_OR_EDIT_MODAL = 'DOCUMENT_HIDE_CREATE_OR_EDIT_MODAL';
export const DOCUMENT_DELETED = 'DOCUMENT_DELETED';
export const DOCUMENT_ADDED = 'DOCUMENT_ADDED';
export const DOCUMENT_GENERATED = 'DOCUMENT_GENERATED';
export const INCREMENT_PROGRESS = 'INCREMENT_PROGRESS';
export const ACTUALISE_COUNT_EXPIRED_DOCUMENTS = 'ACTUALISE_COUNT_EXPIRED_DOCUMENTS';
